define('app/models/Dashboard',['require','config','glu/model','glu/util','./Field','glu/collection','glu/log','app/models/Report','app/models/Benchmark','app/models/BenchmarkCollection','app/models/Segment','app/models/Monitor','app/models/FieldFilter','app/app'],function(require) {
	'use strict';

	var config = require('config'),
		Model = require('glu/model'),
		_ = require('glu/util'),
		Field = require('./Field'),
		Collection = require('glu/collection'),
		log = require('glu/log'),
		Report = require('app/models/Report'),
		Benchmark = require('app/models/Benchmark'),
		BenchmarkCollection = require('app/models/BenchmarkCollection'),
		Segment = require('app/models/Segment'),
		Monitor = require('app/models/Monitor'),
		FieldFilter = require('app/models/FieldFilter'),
		App = require('app/app');

	return Model.extend({
		url: function() {
			return config.apiRoot + 'service/dashboards/' + this.id;
		},

		getReportCollectionUrl: function() {
			return config.apiRoot + 'service/reports?dashboardId=' + this.id;
		},

		getBenchmarkCollectionUrl: function() {
			return config.apiRoot + 'service/benchmarks/' + this.id;
		},

		getSegmentCollectionUrl: function() {
			return config.apiRoot + 'service/segments';
		},

		getMonitorCollectionUrl: function() {
			return config.apiRoot + 'service/monitors?dashboardId=' + this.id;
		},

		initMasterFilter: function() {
			var self = this;

			var mFieldFilter = this.loadMasterFilter();
			if (mFieldFilter === null) {
				mFieldFilter = this.defaultMasterFilter();
			}
			this.set('masterFilter', mFieldFilter);

			self.trigger('masterfilterchange');

			// Set watcher at the end of the execution queue
			window.setTimeout(function() {
				self.listenTo(mFieldFilter, 'change', function() {
					self.saveMasterFilter();
					self.trigger('masterfilterchange');
				});
			}, 0);
		},

		widgets: [],

		initialize: function() {
			this.initializeReportCollection();
			this.initializeMonitorCollection();
			this.initializeSegmentCollection();
			this.initializeBenchmarkCollection();
			this.initializeMasterFilter();
		},

		initializeReportCollection: function() {
			var reportCollection = new Collection([], {
				model: Report
			});

			reportCollection.url = this.getReportCollectionUrl();
			this.set('reportCollection', reportCollection);
		},

		initializeSegmentCollection: function() {
			var segmentCollection = new Collection([], {
				model: Segment
			});

			segmentCollection.url = this.getSegmentCollectionUrl();
			this.set('segmentCollection', segmentCollection);
		},

		initializeBenchmarkCollection: function() {
			var benchmarkCollection = new BenchmarkCollection([], {
				model: Benchmark
			});

			benchmarkCollection.url = this.getBenchmarkCollectionUrl();
			this.set('benchmarkCollection', benchmarkCollection);
		},

		initializeMonitorCollection: function() {
			var monitorCollection = new Collection([], {
				model: Monitor
			});

			monitorCollection.url = this.getMonitorCollectionUrl();
			this.set('monitorCollection', monitorCollection);
		},

		initializeMasterFilter: function() {
			this.listenTo(this, 'sync', this.initMasterFilter);
		},

		parse: function(response) {
			var id = this.id;
			_.each(response.fields, function(f) {
				_.extend(f, {
					dashboardId: id
				});
			});

			var fieldCollection = new Collection(response.fields, {
				model: Field
			});
			fieldCollection.each(function(f) {
				f.set('dashboardId', response.id);
			});

			response.fieldCollection = fieldCollection;
			return response;
		},

		benchmarkCollection: function() {
			return this.get('benchmarkCollection');
		},

		reportCollection: function() {
			return this.get('reportCollection');
		},

		segmentCollection: function() {
			return this.get('segmentCollection');
		},

		monitorCollection: function() {
			return this.get('monitorCollection');
		},

		//public
		//returns DATE or DATETIME fields
		//filtered with 'dashboardMasterfilterFieldIdsFilter' dashboardOptions (if provided)
		//and sorted by the order they appear in 'dashboardMasterfilterFieldIdsFilter'
		dateFields: function() {
			//try to pull the optional filter to be used (or undefined)
			var masterFilterFieldIds,
				defaultDashboardDateFilter,
				dashboardOptions = this.get('dashboardOptions');

			if (dashboardOptions) {
				masterFilterFieldIds = dashboardOptions.dashboardMasterfilterFieldIdsFilter;
				defaultDashboardDateFilter = dashboardOptions.defaultDashboardDateFilter;
			}

			//filter fields by their type
			var fields = _.filter(this.get('fields'), function(field) {
				return field.type === 'DATETIME' || field.type === 'DATE';
			});

			//filter by optional 'filter'
			var res = [];

			// presence of a default dashboard date filter takes precedence over all
			// other filter configurations.
			if (defaultDashboardDateFilter) {
				//find the field from dashboard with this fieldId
				var defaultFld = _.find(fields, function(field) {
					return defaultDashboardDateFilter === field.id;
				});
				if (defaultFld) {
					defaultFld.dashboardId = this.id;
					res.push(defaultFld);
				}
			} else if (masterFilterFieldIds) {
				//if filter provided, then it's the master list we iterate over (to keep the desired order of fields)
				_.each(masterFilterFieldIds, function(fieldId) {
					//find the field from dashboard with this fieldId
					var fld = _.find(fields, function(field) {
						return fieldId === field.id;
					});
					if (fld) {
						res.push(fld);
					}
				});
			} else {
				//otherwise, the order is as in 'fields'
				res = fields;
			}
			return new Collection(res, {
				model: Field
			});
		},

		//returns a default FieldFilter
		defaultMasterFilter: function() {
			var mFieldFilter = new FieldFilter({
				fieldObject: this.dateFields().at(0),
				operator: 'ROLLINGDATERANGE'
			});

			mFieldFilter.setValue(0, {
				backUnitType: 'DAY',
				backUnitLength: 7,
				durationUnitType: 'DAY',
				durationUnitLength: 7
			});

			return mFieldFilter;
		},

		//private
		//will access User.js trying to restore a master filter associated with this dashboard.
		//If it can not do so (for whatever reason) it will return 'null'.
		//Otherwise (on success) the correct master filter will be returned.
		loadMasterFilter: function() {
			var key = this.getMasterFilterStorageKey();
			var json = App.user.loadObject(key, null);
			var res = null;
			if (json !== null) {
				res = new FieldFilter({});
				try {
					res.fromJSON(json, this);
				} catch (e) {
					log.warn('Corrupt data for \'' + key + '\' key. Can not do FieldFilter.fromJSON() due to: ' + e.toString());
					res = null;
				}
			}
			return res;
		},

		//private
		//saves current master filter (if it is not 'undefined')
		saveMasterFilter: function() {
			var key = this.getMasterFilterStorageKey();
			var obj = this.getMasterFilter();

			if (obj && obj.isValid()) {
				obj = obj.toJSON();
				App.user.saveObject(key, obj);
			}
		},

		//public
		//returns the key which is going to be used for storing master filter
		getMasterFilterStorageKey: function() {
			return 'dashboard-' + this.id + '-masterfilter';
		},

		//public
		//simply returns whatever is set as a current master filter
		//returns instance of FieldFilter or 'undefined'
		getMasterFilter: function() {
			return this.get('masterFilter');
		},

		setMasterFilter: function(filter) {
			this.set('masterFilter', filter);
		}
	});
});

